import React from 'react'

import clsx from 'clsx'

import Button from 'components/Button'
import UserSignedInButton from 'components/UserSignedInButton'
import ServerViewport from 'context/ViewportContext/ServerViewport'
import { addEvent } from 'lib/AnalyticsGDM/analytics'
import { ROUTE_NAMES } from 'routes'
import routeService from 'services/routes'

import AuthButtons from './components/AuthButtons'

import classes from './SiteMenus.module.scss'

/** @type {import('./types').default} */
const SiteMenus = ({ user, colorVariant = 'dark' }) => {
  const colorVariantClass = `is-${colorVariant}`

  return (
    <>
      <ServerViewport
        up="lg"
        renderIf={
          <>
            <Button
              className={clsx(classes.button, classes[colorVariantClass])}
              variant="text"
              component="a"
              href="/browse/"
              {...addEvent(
                {
                  engagementComponent: 'header',
                  engagementDestination: 'go-to_software-categories',
                  engagementDetails: 'button_browse',
                  name: 'engagement_navigation',
                },
                {
                  noClientSide: true,
                }
              )}
            >
              Software categories
            </Button>
            <Button
              {...addEvent(
                {
                  engagementComponent: 'header',
                  engagementDestination: 'go-to_resources',
                  engagementDetails: 'button_resources',
                  name: 'engagement_navigation',
                },
                {
                  noClientSide: true,
                }
              )}
              className={clsx(classes.button, classes[colorVariantClass])}
              variant="text"
              component="a"
              href="/resources/"
            >
              Blog & research
            </Button>
            <Button
              {...addEvent(
                {
                  engagementComponent: 'header',
                  engagementDestination: 'go-to_about',
                  engagementDetails: 'button_about',
                  name: 'engagement_navigation',
                },
                {
                  noClientSide: true,
                }
              )}
              className={clsx(classes.button, classes[colorVariantClass])}
              variant="text"
              component="a"
              href={routeService.generatePath(ROUTE_NAMES.ABOUT)}
            >
              About us
            </Button>
          </>
        }
      />

      <ServerViewport
        up="md"
        renderIf={
          <>
            {user ? (
              <UserSignedInButton
                className={clsx(classes.signIn, classes[colorVariantClass])}
                name={user.first_name}
                avatarSrc={user.picture_url}
              />
            ) : (
              <AuthButtons colorVariant={colorVariant} />
            )}
          </>
        }
      />
    </>
  )
}

export default SiteMenus
